import React from 'react'
import Modal from 'react-responsive-modal'
import { connect } from 'react-redux'
import AttractionPromoActions from '../../Redux/AttractionPromoRedux'
import Create from '../../Containers/AttractionPromo/Create'
import Update from '../../Containers/AttractionPromo/Update'
import Image from '../../Containers/AttractionPromo/Image'
import Delete from '../../Containers/AttractionPromo/Delete'
import AdvancedFilter from '../../Components/AdvancedFilter'
import AdvancedTable from '../../Components/AdvancedTable'
import Pagination from 'react-js-pagination'

class AttractionPromo extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 1,
      modal: null,
      detail: {},
      selectedCountry: {},
      filter: {
        page: 1
      },
      countrySelector: [{ label: 'ALL', value: '' }]
    }
  }

  _selectItem = (detail, modal, method) => {
    switch (method) {
      case 'default':
        this.setState({ detail })
        break
      case 'selectCountry':
        let selectedCountry = {
          value: detail.country.id,
          label: detail.country.name
        }
        this.setState({ detail, selectedCountry })
        break
      default:
        return null
    }
    this._triggerModal(modal)
  }

  _triggerModal = (modal) => {
    this.setState({ modal })
  }

  _manipulateState = (props) => {
    this.setState({ filter: props })
  }

  _changePage = (page) => {
    this.setState({ page })
    this._fetchAttractionPromo(null, page)
  }

  _renderImageContainer = (detail) => {
    if ((detail.image_file || detail.image_url) === null) {
      return (
        <button onClick={() => this._selectItem(detail, 'image', 'default')} className='btn btn-primary'>
          <i className='fa fa-plus' /> Assign
        </button>
      )
    } else {
      return (
        <img
          onClick={() => this._selectItem(detail, 'image', 'default')}
          src={detail.image_url}
          alt={detail.image_file}
          height='100px'
          width='100px'
          style={{ cursor: 'pointer' }}
        />
      )
    }
  }

  _fetchAttractionPromo = (event, page) => {
    if (event) { event.preventDefault() }
    let filter = { ...this.state.filter }
    if (page) filter.page = page
    let data = filter
    this.props.get(data)
  }

  _getCountrySelector = (meta) => {
    let countrySelector = this.state.countrySelector
    if (meta) {
      meta.list_country.map((item, i) => (
        countrySelector[i + 1] = { label: item.name, value: item.id }
      ))
      this.setState({ countrySelector })
    }
  }

  componentDidUpdate = (prevProps) => {
    const { meta } = this.props.attractionPromo.data
    if (prevProps !== this.props) {
      this._getCountrySelector(meta)
    }
  }

  componentDidMount = () => {
    this.props.get()
  }

  render () {
    const { attractionPromo } = this.props
    const { data, meta } = attractionPromo.data
    return (
      <section className='section'>
        <header className='title-block'>
          <div className='d-flex justify-content-between'>
            <h1 className='title'>
              Attraction Promo Email
              {
                (attractionPromo.fetching || attractionPromo.processing) &&
                <div className='badge badge-info ml-2'>Loading ...</div>
              }
            </h1>
            <button className='btn btn-primary ml-auto' onClick={() => this._triggerModal('create')}><i className='fa fa-plus' /> Create New</button>
          </div>
          <AdvancedFilter
            filters={[
              {
                type: 'selector',
                name: 'Country',
                field: 'country',
                selectors: this.state.countrySelector
              }
            ]}
            manipulateState={(props) => this._manipulateState(props)}
            callback={(event) => this._fetchAttractionPromo(event)}
          />
          {
            !(attractionPromo.processing || attractionPromo.fetching) && attractionPromo.err &&
            <div className='alert alert-danger'>{attractionPromo.err}</div>
          }
        </header>

        <AdvancedTable
          colSpan={9}
          header={[
            { field: 'Name' },
            { field: 'Country' },
            { field: 'Coupon Code' },
            { field: 'URL' },
            { field: 'Description' },
            { field: 'Discount' },
            { field: 'Image' },
            { field: 'Edit' },
            { field: 'Delete' }
          ]}
          body={
            data &&
            data.length > 0 &&
            data.map(item => ([
              { field: item.name },
              { field: item.country.name },
              { field: item.coupon_code },
              { field: item.url },
              { field: item.description },
              { field: item.discount_amount },
              { field: this._renderImageContainer(item) },
              {
                field: <button
                  className='btn btn-primary'
                  onClick={() => this._selectItem(item, 'update', 'selectCountry')}>
                  <i className='fa fa-edit' />
                </button>
              },
              {
                field: <button
                  className='btn btn-danger'
                  onClick={() => this._selectItem(item, 'delete', 'default')}>
                  <i className='fa fa-trash' />
                </button>
              }
            ]))
          }
        />

        <section className='section text-center'>
          {
            (meta && meta.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={meta.page || this.state.page}
              itemsCountPerPage={meta.limit}
              totalItemsCount={meta.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.modal === 'create'} onClose={() => this._triggerModal(null)}>
          <Create closeModal={() => this._triggerModal(null)} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.modal === 'update'} onClose={() => this._triggerModal(null)}>
          <Update closeModal={() => this._triggerModal(null)} detail={this.state.detail} selectedCountry={this.state.selectedCountry} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.modal === 'image'} onClose={() => this._triggerModal(null)}>
          <Image closeModal={() => this._triggerModal(null)} detail={this.state.detail} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.modal === 'delete'} onClose={() => this._triggerModal(null)}>
          <Delete uuid={this.state.detail.id} name={this.state.detail.name} closeModal={() => this._triggerModal(null)} />
        </Modal>

      </section>
    )
  }
}

const stateToProps = (state) => ({
  attractionPromo: state.attractionPromo
})

const dispatchToProps = (dispatch) => ({
  get: (data) => dispatch(AttractionPromoActions.attractionPromoRequest(data))
})

export default connect(stateToProps, dispatchToProps)(AttractionPromo)



// WEBPACK FOOTER //
// ./src/Pages/Misc/AttractionPromo.js